// extracted by mini-css-extract-plugin
export var header = "header-module--header--knWBH";
export var logoContainer = "header-module--logoContainer--rpQf1";
export var logo = "header-module--logo--y97xu";
export var navLinks = "header-module--navLinks--djqSq";
export var desktop = "header-module--desktop--07K5q";
export var mobile = "header-module--mobile--KPRa6";
export var open = "header-module--open--EKQfW";
export var closed = "header-module--closed--7Kdf5";
export var hamburger = "header-module--hamburger--mdm6I";